export default __webpack_public_path__ + "static/media/maisons_laffitte5.d31ba3ca.jpg";